import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ApiService } from '../services/api.service';

export const authGuard: CanActivateFn = (route, state) => {
  console.log('### authGuard CanMatchFn route', route);
  console.log('### authGuard CanMatchFn state', state);

  const _api = inject(ApiService);
  const _router = inject(Router);

  return _api.post('api/sanctum/user', {}).pipe(
    map((response: any) => {
      console.log('### authGuard CanActivateFn response', response);

      let user: any = response.user;

      _api.userEmitter.next(user);

      if (!user) {
        _router.navigate(['/']);
      }

      return !!user;
    }),
    catchError((error: any) => {
      console.log('### authGuard CanActivateFn catchError error', error);
      _api.userEmitter.next(null);
      return of(true);
    })
  );
};
